import React, { useEffect } from "react";

const EMOJI_CATEGORIES = [
  {
    name: "Frequently Used",
    emojis: ["👍", "❤️", "😂", "😮", "😢", "🙏", "🔥", "👏", "🎉", "💯", "✨", "🙌"],
  },
  {
    name: "Smileys & Emotion",
    emojis: ["😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😇", "🙂", "😉", "😍", "🥰", "😘", "😗", "😋", "😛", "😜", "🤪", "🤨", "🧐", "🤓", "😎", "🤩", "🥳"],
  },
  {
    name: "Hands & Gestures",
    emojis: ["👍", "👎", "👌", "🤌", "✌️", "🤞", "🤟", "🤘", "🤙", "👈", "👉", "👆", "👇", "☝️", "👋", "🤚", "🖐️", "✋", "🖖", "👏", "🤝", "🙏", "💪"],
  },
  {
    name: "Symbols & Hearts",
    emojis: ["❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔", "❤️‍🔥", "💖", "💘", "💝", "🌟", "⭐", "💫", "✨", "🔥", "💯", "✅", "✔️"],
  },
];

export default function ExtendedEmojiModal({ isOpen, onClose, onSelectEmoji }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="wa-modal-backdrop"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Choose Emoji Reaction"
    >
      <div
        className="wa-emoji-picker-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="wa-emoji-picker-header">
          <span className="wa-emoji-picker-title">React with Emoji</span>
          <button
            type="button"
            className="wa-modal-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className="wa-emoji-picker-scroll">
          {EMOJI_CATEGORIES.map((cat, idx) => (
            <div key={idx} className="wa-emoji-category-section">
              <div className="wa-emoji-category-title">{cat.name}</div>
              <div className="wa-emoji-grid">
                {cat.emojis.map((emoji, eIdx) => (
                  <button
                    key={eIdx}
                    type="button"
                    className="wa-emoji-pick-btn"
                    onClick={() => {
                      onSelectEmoji(emoji);
                      onClose();
                    }}
                    title={emoji}
                  >
                    <span>{emoji}</span>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
